import { SortByFn } from "react-table";

export const alphanumeric: SortByFn<any> = (rowA, rowB, columnId) => {
  const a: string = rowA.values[columnId] || "";
  const b: string = rowB.values[columnId] || "";

  return a.localeCompare(b);
};
